import styles from "./SubscriptionSelectContent.module.css";

export const NoSubscriptionSelectOption = () => {
  return (
    <div className={styles.selectOptionLayout}>
      <span className={styles.planName}>No Subscription</span>
    </div>
  );
};
